<template>
    <async-wrapper :data="store" :loading="async.loading" :error="async.error">
        <template slot="dataComponent">
            <div v-if="store && store[STORE_PROFILES.fields.address]" class="row">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="media mt-3">
                                <img
                                    v-if="store[STORE_PROFILES.fields.logoURL]"
                                    :src="store[STORE_PROFILES.fields.logoURL]"
                                    class="align-self-center mr-3 border logo-image"
                                    alt="Store Logo"
                                    width="64"
                                    height="64"
                                />
                                <div class="media-body">
                                    <h4 class="card-title my-0">{{ store[STORE_PROFILES.fields.name] }}</h4>
                                    <p class="hint mt-0">{{ store.id }}</p>
                                    <badge :type="store[STORE_PROFILES.fields.visibility] === VISIBILITY_STATUS.VISIBLE ? 'success' : 'danger'">
                                        {{ store[STORE_PROFILES.fields.visibility] === VISIBILITY_STATUS.VISIBLE ? 'Visible' : 'Hidden' }}
                                    </badge>
                                    <badge :type="store[STORE_PROFILES.fields.approval] === STORE_APPROVAL_STATUS.APPROVED ? 'success' : 'danger'">
                                        {{ store[STORE_PROFILES.fields.approval] === STORE_APPROVAL_STATUS.APPROVED ? 'Approved' : 'Pending Approval' }}
                                    </badge>
                                </div>
                            </div>
                        </div>
                        <div class="card-body d-flex flex-column">
                            <div class="row my-3">
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Phone Number</p>
                                    <h6><phone-number :value="store[STORE_PROFILES.fields.phoneNumber]"></phone-number></h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Website</p>
                                    <h6>{{ store[STORE_PROFILES.fields.website] }}</h6>
                                </div>
                                <div class="col-xl-12 my-2"></div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Address Line 1</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.address1] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Address Line 2</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.address2] || 'N/A' }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Postal Code</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.postalCode] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">City</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.city] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Province</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.province] }}</h6>
                                </div>
                                <div class="col-xl-6">
                                    <p class="hint mb-0">Country</p>
                                    <h6>{{ store[STORE_PROFILES.fields.address][STORE_PROFILES.address.country] }}</h6>
                                </div>
                                <div v-if="store[STORE_PROFILES.fields.hours]" class="col-xl-12 mt-3">
                                    <store-hours :hours="store[STORE_PROFILES.fields.hours] || false"></store-hours>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body">
                            <pagination-table
                                :data="firebaseObjectToArray(store[STORES.fields.storeEmployees])"
                                :propsToSearch="['id', USERS_STORE.fields.email, USERS_STORE.fields.phoneNumber]"
                                searchPlaceholder="Search id, email, phone"
                                title="Employees"
                            >
                                <template slot="table" slot-scope="scope">
                                    <store-employees-table :data="scope.data"></store-employees-table>
                                </template>
                            </pagination-table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template slot="loadingComponent">
            <i class="fa fa-circle-o-notch fa-2x fa-spin mt-5"></i>
        </template>
        <template slot="errorComponent">
            <p>{{ async.error }}</p>
        </template>
    </async-wrapper>
</template>
<script>
import { firebaseObjectToArray } from '@/utils'
import { VISIBILITY_STATUS, STORE_APPROVAL_STATUS } from '@/utils/constants'
import StoreHours from './StoreHours'
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
import { STORES, STORE_PROFILES, USERS_STORE } from 'db'
import { Badge } from '@/components/UIComponents'
import PaginationTable from 'Shared/Tables/PaginationTable'
import StoreEmployeesTable from 'Shared/Tables/StoreEmployeesTable'
export default {
    components: {
        PaginationTable,
        StoreEmployeesTable,
        AsyncWrapper,
        Badge,
        StoreHours
    },
    props: {
        storeId: {
            type: [String, Boolean],
            required: true
        }
    },
    data() {
        return {
            VISIBILITY_STATUS,
            STORE_APPROVAL_STATUS,
            STORES,
            STORE_PROFILES,
            USERS_STORE
        }
    },
    computed: {
        async() {
            return {
                loading: this.$store.getters['storeProfiles/GET_ASYNC'].loading || this.$store.getters['stores/GET_ASYNC'].loading,
                error: this.$store.getters['storeProfiles/GET_ASYNC'].error || this.$store.getters['stores/GET_ASYNC'].error
            }
        },
        store() {
            return {
                ...this.$store.getters['stores/GET_STORE'],
                ...this.$store.getters['storeProfiles/GET_STORE_PROFILE']
            }
        }
    },
    created() {
        this.$store.dispatch('storeProfiles/FETCH_STORE_PROFILE_BY_ID', {
            id: this.storeId
        })
        this.$store.dispatch('stores/FETCH_STORE_BY_ID', {
            id: this.storeId
        })
    },
    beforeDestroy() {
        this.$store.dispatch('storeProfiles/REMOVE_STORE_PROFILE_REFERENCE', {
            id: this.storeId
        })
        this.$store.dispatch('stores/REMOVE_STORE_REFERENCE', {
            id: this.storeId
        })
    },
    methods: {
        firebaseObjectToArray
    }
}
</script>

<style lang="scss" scoped>
.card {
    img.logo-image {
        position: relative;
        max-width: 64px;
        max-height: 64px;
    }
}
.p-badge {
    margin-right: 0.25rem;
}
</style>
